<loading [isLoading]="loadingCanView" [success]="true"></loading>

@if (!loadingCanView) {
    @if (canView && username) {
        <div class="flex flex-col gap-2 w-[320px] sm:w-[620px] md:w-[748px] lg:w-[1000px] max-w-[320px] sm:max-w-[620px] md:max-w-[748px] lg:max-w-[1000px] overflow-auto">
            <loading [isLoading]="loadingStubs" [success]="loadingStubsSuccess"></loading>
            <!-- Post List -->
            <div class="flex flex-col gap-2" [ngClass]="{'hidden' : showEditor}">
                <div class="flex flex-row items-center">
                    <div class="font-bold grow">
                        Posts
                    </div>
                    <button (click)="onNewPostClicked()" class="w-[12ch] text-sm p-1 bg-slate-50 rounded-sm shadow-sm hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:bg-slate-100 disabled:hover:text-slate-500 disabled:hover:cursor-default disabled:hover:border-transparent">
                        New Post
                    </button>
                </div>
                <div class="flex flex-col bg-slate-100 text-sm rounded shadow">
                    <div class="flex flex-row gap-4 items-center p-2 bg-ponder-light text-slate-100 rounded-t-sm">
                        <div class="grow">Title</div>
                        <div class="w-[16ch]">Created At</div>
                        <div class="w-[16ch]">Updated At</div>
                        <div class="w-[8ch] text-center"></div>
                        <div class="w-[8ch] text-center"></div>
                    </div>
                    <div class="flex flex-col gap-2">
                        @if (posts.length) {
                            @for (post of posts ; track post.id) {
                                <div class="flex flex-row gap-4 items-center p-2" [ngClass]="{ 'bg-slate-50' : $even, 'bg-slate-100' : $odd}">
                                    <div class="grow">{{ post.title }}</div>
                                    <div class="w-[16ch]" title="{{ post.createdAt }}">{{ post.createdAt | date }}</div>
                                    <div class="w-[16ch]" title="{{ post.modifiedAt }}">{{ post.modifiedAt | date }}</div>
                                    <button (click)="onEditClicked(post)" class="w-[8ch] text-center hover:text-ponder-linkhover">Edit</button>
                                    <button (click)="onDeleteClicked(post)" class="w-[8ch] text-center hover:text-red-700">Delete</button>
                                </div>
                            }
                        }
                    </div>
                </div>
            </div>
            <!-- Post Editor -->
            <div id="hi" class="flex flex-col gap-2" [ngClass]="{'hidden' : !showEditor}">
                <div class="flex flex-row max-w-full">
                    <news-post-editor class="grow" [stub]="selectedStub" [username]="username"></news-post-editor>
                </div>
            </div>
        </div>
    } @else {
        <admin-unauthorized></admin-unauthorized>
    }
}
<ng-template #confirmationModalTemplate></ng-template>